import { render, staticRenderFns } from "./ProductCompensationPage.vue?vue&type=template&id=6cb57212&"
import script from "./ProductCompensationPage.vue?vue&type=script&lang=js&"
export * from "./ProductCompensationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports